import { type JSX } from 'react';
import { TableV2 } from '@/shared/components/molecules/TableV2';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import useRemotePagination from '@/shared/hooks/useRemotePagination';
import BlockRow from '../../components/BlockPage/BlockRow';
import { Layout } from '../../components/Layout';
import { getAllBlocksQuery, getTotalBlockCountQuery } from '../../graphql/explorer/blocks';
import useBlockCounts from '../../hooks/useBlockCounts';

const BlocksPage = (): JSX.Element => {
  const { data } = useGqlQuery(getTotalBlockCountQuery);
  const totalCount = data?.latestBlock?.nodes[0].totalCount;

  const {
    data: blocks,
    isLoading: blocksLoading,
    error,
    paginationControls,
  } = useRemotePagination(getAllBlocksQuery, {
    useQueryParam: true,
    enabled: totalCount !== undefined,
    totalCount: typeof totalCount === 'number' ? totalCount + 1 : undefined,
  });
  const edges = blocks?.allBlocks?.edges;
  const totalBlocks = totalCount;

  const startBlockHeight = edges && edges.length > 0 ? edges[edges.length - 1].node.id : undefined;
  const endBlockHeight = edges?.[0].node.id;

  const countsFor = useBlockCounts(startBlockHeight, endBlockHeight);

  const tableRows =
    edges?.map((edge) => (
      <BlockRow key={edge.node.id} block={edge.node} counts={countsFor(edge.node.id)} />
    )) || [];

  if (error) throw error;
  return (
    <Layout title="Blocks">
      <div className="flex flex-col space-y-4">
        <div>
          <div className="text-[32px] text-cf-white"> Blocks </div>
          {totalBlocks && <div className="text-cf-light-2">{`Total blocks: ${totalBlocks}`}</div>}
        </div>
        <TableV2
          columns={['Block', 'Events', 'Extrinsics', 'Author', { name: 'Age', alignment: 'right' }]}
          isLoading={blocksLoading}
          rows={tableRows}
          paginationControls={paginationControls}
        />
      </div>
    </Layout>
  );
};

export default BlocksPage;
